import { render, staticRenderFns } from "./UserDeletion.vue?vue&type=template&id=7f274d92&scoped=true&"
import script from "./UserDeletion.vue?vue&type=script&lang=ts&"
export * from "./UserDeletion.vue?vue&type=script&lang=ts&"
import style0 from "./UserDeletion.vue?vue&type=style&index=0&id=7f274d92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f274d92",
  null
  
)

export default component.exports